import { useEffect, useMemo } from 'react';
import { Smartphone } from 'lucide-react';
import { APP_SCHEME } from '@/lib/native';

// Puente web → app tras Google en el navegador del sistema. No inicia sesión en la web.
export default function AppAuthCallback() {
  const hash = window.location.hash || '';
  const deepLink = useMemo(() => `${APP_SCHEME}://auth/callback${hash}`, [hash]);
  const ok = hash.includes('session_id=');

  useEffect(() => {
    if (ok) window.location.href = deepLink;
  }, [ok, deepLink]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-6" data-testid="app-auth-callback">
      <div className="max-w-sm w-full border border-slate-200 bg-white p-6 text-center">
        <Smartphone className="mx-auto h-8 w-8 text-slate-900" />
        <h1 className="mt-3 font-display font-bold text-xl text-slate-900">
          {ok ? 'Volver a AutoMarket' : 'Enlace no válido'}
        </h1>
        <p className="mt-2 text-sm text-slate-600">
          {ok ? 'Toca el botón para terminar de iniciar sesión en la app.' : 'Vuelve a la app e inténtalo de nuevo.'}
        </p>
        {ok && (
          <a href={deepLink} data-testid="app-auth-callback-open-app"
             className="mt-5 inline-flex h-11 items-center justify-center bg-slate-900 px-6 font-bold text-white">
            Abrir la app
          </a>
        )}
      </div>
    </div>
  );
}
